// DS: MO2.4 Core Sale Branded Button
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData } from '@wix/da-bi/pkg/events';
import { useCurrentPromo } from '../../../../utils/hooks/useCurrentPromo';
import noop from '../../../../utils/noop';
import SaleIndicator from '../../lego/SaleIndicator';
import s from './BuyCoreBrandedButton.scss';
const BuyCoreBrandedButton = (_param)=>{
    var { promo, className, biData, referer, size, onClick = noop, children, withSaleSparkles } = _param, props = _object_without_properties(_param, [
        "promo",
        "className",
        "biData",
        "referer",
        "size",
        "onClick",
        "children",
        "withSaleSparkles"
    ]);
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const currentPromo = useCurrentPromo('self') || promo;
    const buttonLabel = isMobile ? t('common.getCore') : children;
    return /*#__PURE__*/ React.createElement(BrandedButton, _object_spread_props(_object_spread({}, props), {
        size: size,
        className: c(className, s[`root-${size}`]),
        variant: "core-orange",
        href: Url.coreMembershipLink(referer),
        target: "_blank",
        onClick: onClick,
        biData: BiData(_object_spread({
            evid: 500
        }, biData))
    }), buttonLabel, (currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.discountValuePercent) && /*#__PURE__*/ React.createElement(SaleIndicator, {
        className: s['sale'],
        size: size === 'small' ? 'small' : 'medium',
        background: "black",
        discount: currentPromo.discountValuePercent,
        withSparkles: withSaleSparkles
    }));
};
BuyCoreBrandedButton.displayName = 'BuyCoreButton';
export default BuyCoreBrandedButton;
